// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-pgm[data-v-c9d0af00]{width:120px}.stone-rebrand-logo[data-v-c9d0af00]{height:32px;width:auto}", ""]);
// Exports
module.exports = exports;
